import type { MenuTreeProps } from "./menu-tree.type";

import { Tree } from "antd";
import classNames from "classnames";

import { MenuTreeRow } from "./menu-tree-row";

import "./menu-tree.style.less";

export const MenuTree = <Data extends object>({
  items,
  selectedKey,
  onSelectedItemChange,
  renderTitle,
  renderDescription,
  renderExtra,
  className,
}: MenuTreeProps<Data>) => {
  const firstItemKey = items?.[0]?.key;

  return (
    <Tree
      treeData={items}
      selectedKeys={selectedKey ? [selectedKey] : undefined}
      defaultSelectedKeys={firstItemKey ? [firstItemKey] : undefined}
      onSelect={(_, info) => {
        const { key, title, data } = info.node;
        onSelectedItemChange?.({ key, title, data });
      }}
      showLine
      defaultExpandAll
      className={classNames("menu-tree", className)}
      titleRender={(item) => (
        <MenuTreeRow
          item={item}
          renderTitle={renderTitle}
          renderDescription={renderDescription}
          renderExtra={renderExtra}
        />
      )}
    />
  );
};
